import LazyLoad from 'vanilla-lazyload';

/**
 * Notes overlay loads HTML asynchronously. Lazy images keep data-src only,
 * so they must be (re)registered with LazyLoad after each note load.
 * Uses the note content as IntersectionObserver root because it scrolls
 * independently of the page.
 */
class NotesLazyLoad {
  constructor() {
    this.instance = null;
    this.observed = false;

    document.addEventListener('noteLoaded', () => {
      this.ensureObserver();
      // Wait a frame so the overlay is visible and laid out.
      window.requestAnimationFrame(() => this.refresh());
    });

    document.addEventListener('noteClosed', () => {
      this.destroyInstance();
    });

    this.ensureObserver();
  }

  ensureObserver() {
    if (this.observed) {
      return;
    }

    const content = document.querySelector('.js-nhsnote-box-content');
    if (!content) {
      return;
    }

    this.observed = true;

    // reloadPopup() replaces innerHTML without dispatching noteLoaded
    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(() => this.refresh());
    });

    observer.observe(content, { childList: true });
  }

  refresh() {
    const content = document.querySelector('.js-nhsnote-box-content');
    if (!content || !content.querySelector('.lazy')) {
      this.destroyInstance();
      return;
    }

    this.destroyInstance();

    this.instance = new LazyLoad({
      container: content,
      elements_selector: '.lazy',
    });
  }

  destroyInstance() {
    if (this.instance) {
      this.instance.destroy();
      this.instance = null;
    }
  }
}

export default NotesLazyLoad;
